import { useMemo, useState } from "react";
import axios from "axios";
import ShortUniqueId from "short-unique-id";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import { useDispatch, useSelector } from "react-redux";
import {
  apiUrl,
  keysToGenerateUnqiueString,
  razorpayKey,
} from "../../constants";
import { FormHelperText, Grid, Typography } from "@mui/material";
import { openAuthModal } from "../../utils/store/slice/appSlice";
import ConfirmationModal from "../windowPurchase/modal";
import AddMoreModal from "./addMore";
import { fetchSelf } from "../../actions/user";
import Invoice from "../invoice";
import InvoiceForCust from "../invoice/InvoiceForCust";
import { toast } from "react-toastify";

const addScript = (src) => {
  const script = document.createElement("script");
  script.src = src;
  document.querySelector("body").appendChild(script);
};
let funingocoinsfrombooknow = 0;

export const handleFuningocoinsFromBooknow = (value) => {
  funingocoinsfrombooknow = value;
};

const PaymentButton = ({
  code,
  values,
  persons,
  setPersonsData,
  discount,
  regularPackageId,
  usedFuningoMoney,
  setShowTicket,
  handleResetBookForm,
  premiumDiscount,
  onClick,
}) => {
  const userData = useSelector((store) => store.userSlice.userData);
  const isLoggedIn = useSelector((store) => store.userSlice.isLoggedIn);
  const dispatch = useDispatch();
  const [consentFormOpen, setConsentFormOpen] = useState(false);
  const [addMoreModalOpen, setAddMoreModalOpen] = useState(false);
  const [payment, setpayment] = useState(false);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState("");
  const [invoiceData, setInvoiceData] = useState({});
  const [showInvoice, setShowInvoice] = useState(false);

  const openModalAuth = () => {
    dispatch(openAuthModal());
  };

  const uid = new ShortUniqueId({
    length: 6,
    dictionary: keysToGenerateUnqiueString,
  });

  const { details } = useMemo(() => {
    let summation = 0;
    let details = persons.map((item) => {
      const personTicket = {
        person_name: values.name,
        age: values.age,
        gender: values.gender,
        package: values.details || null,
        amount: parseInt(values.price) || 0,
      };
      return personTicket;
    });
    let price = values.price;
    let cgst = price * 0.09;
    let sgst = price * 0.09;
    let finalVal = price + cgst + sgst;
    summation += finalVal - discount + premiumDiscount;
    setTotal(summation);
    setCgst(cgst);
    setSgst(sgst);
    return { details, total };
  }, [persons, premiumDiscount]);

  const deleteTicketAPI = async (shortId) => {
    const token = localStorage.getItem("token");
    await axios.delete(`${apiUrl}/ticket/${shortId}`, { headers: { token } });
  };
  const regId = values.details.map((curr) => {
    if (curr.packageType == "regular") return curr.package;
  });

  const handlePayment = async (callback) => {
    try {
      const ticket_id = uid();
      const token = localStorage.getItem("token");

      const invoiceDataToSet = {
        count: values.count || 0,
        total_amount: values.price,
        details: details,
        token: token,
        payment_mode: "RAZORPAY",
        cgst,
        sgst,
        discount: discount,
        dob: values.dob || undefined,
        ticket_id: ticket_id,
        phone_no: values.phone,
        name: values.name,
      };

      setInvoiceData(invoiceDataToSet);

      const requestData = {
        preferred_slot: values.time,
        cgst,
        sgst,
        discount,
        total_amount: total,
        details: values.details,
        fun_date: new Date(values.date),
        short_id: ticket_id,
        phone_no: "+91-" + values.phone,
        used_funingo_money: usedFuningoMoney,
        coupon: discount?.code,
        count: values.count,
      };

      addScript("https://checkout.razorpay.com/v1/checkout.js");
      let response = await axios.post(
        `${apiUrl}/ticket/create-order`,
        requestData,
        {
          headers: {
            token: token,
          },
        }
      );
      response = response.data;

      if (response.success === true && total === 0) {
        setShowInvoice(true);
        handleResetBookForm();
        callback?.(ticket_id);
        setPersonsData({});
        setShowTicket({
          show: true,
          data: response.ticket,
        });
        setpayment(true);
        return;
      }

      const options = {
        key: razorpayKey,
        name: "Funingo Adventure Park",
        amount: total,
        currency: "INR",
        description: "Test Transaction",
        order_id: response.id,
        handler: async (res) => {
          try {
            let resp = await axios.post(
              `${apiUrl}/ticket/verify-payment`,
              {
                ...res,
                order_id: response.id,
                short_id: ticket_id,
              },
              {
                headers: {
                  token: token,
                },
              }
            );
            await dispatch(fetchSelf());
            if (resp) {
              if (regId.length > 0) {
                const resCountRegularPackage = await axios.put(
                  `${apiUrl}/package?id=${regId[0]}`
                );
              }
              setShowInvoice(true);
              handleResetBookForm();
              callback?.(ticket_id);
              setPersonsData({});
              setShowTicket({
                show: true,
                data: resp.data.ticket,
              });
            }
            toast.success("Ticket Booked", {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } catch (error) {
            toast.error("Payment Unsuccess", {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            console.log(error.message, error);
          }
        },
        modal: {
          ondismiss: function () {
            deleteTicketAPI(ticket_id);
          },
        },
        prefill: {
          name: userData?.name ? userData.name : "",
          email: userData?.email ? userData.email : "",
          contact: userData?.phone_no ? userData.phone_no : "",
        },
        theme: {
          color: "#3399cc",
        },
      };
      const razorpay = window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Payment Error!!", error.message, error);
    }
  };

  return (
    <>
      {addMoreModalOpen && (
        <AddMoreModal
          open={addMoreModalOpen}
          onClose={() => setAddMoreModalOpen(false)}
          onContinue={() => setConsentFormOpen(true)}
          amount={1000 - total}
        />
      )}

      {/* Conditionally render InvoiceForCust component */}
      {showInvoice && (
        <InvoiceForCust
          invoiceData={invoiceData}
          onClose={() => setShowInvoice(false)}
        />
      )}

      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <FormHelperText error>{error}</FormHelperText>
        <Button
          endIcon={<SendIcon />}
          variant="contained"
          sx={{
            background: "#2CC248",
            boxShadow: "0px 2.5 9 0px rgba(0, 0, 0, 0.25)",
            borderRadius: "50px",
            padding: "10px 30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            "&:hover": {
              background: "#1e8e33",
            },

            "&.Mui-disabled": {
              background: "#2CC248",
              boxShadow: "0px 2.5 9 0px rgba(0, 0, 0, 0.25)",
              borderRadius: "50px",
              padding: "10px 30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          }}
          onClick={async () => {
            await onClick();
            if (!isLoggedIn) {
              dispatch(openAuthModal());
              return;
            }
            if (persons?.length === 0) {
              setError("Save atleast one person before continuing");
              return;
            }

            if (isLoggedIn) {
              handlePayment();
              setConsentFormOpen(true);
            } else {
              dispatch(openModalAuth());
            }
          }}
        >
          <Typography
            sx={{
              fontFamily: "Luckiest Guy",
              fontSize: "24px",
              position: "relative",
              textAlign: "center",
              color: "white",
            }}
          >
            Buy Now
          </Typography>
        </Button>
      </Grid>
    </>
  );
};

export default PaymentButton;
